module.exports = __webpack_public_path__ + "static/media/newTextMessageSound.27fbe8a5.wav";